import { useEffect, useState } from 'react';

export function useAppConfig() {
  const [config, setConfig] = useState(null);
  useEffect(() => {
    fetch('/config/config.json', { cache: 'no-store' })
      .then((res) => { console.log('config status', res.status, res.headers.get('content-type')); return res.json(); })
      .then((json) => { console.log('config payload', json); setConfig(json); })
      .catch((e) => { console.error('config failed', e); setConfig({ BACKEND_URL: '' }); });
  }, []);
  return config;
}
